export const questionType = [
  { label: '选择题', value: 1 },
  { label: '判断题', value: 2 }
]

export const questionDifficulty = [
  { label: '简单', value: 1 },
  { label: '中等', value: 2 },
  { label: '困难', value: 3 }
]

export const questionStatus = [
  { label: '草稿', value: 0 },
  { label: '启用', value: 1 },
  { label: '禁用', value: 9 }
]

export const examStatus = [
  { label: '待发布', value: 4 },
  { label: '已发布', value: 5 },
  { label: '考试中', value: 6 },
  { label: '已结束', value: 7 },
  { label: '已关闭', value: 8 },
  { label: '已中止', value: 15 }
]

export const difficultyTexts = questionDifficulty.map(i => i.label)

const choicesKey = ['A', 'B', 'C', 'D', 'E', 'F']

export function pushChoices(size, idx) {
  const choices = []
  for (let index = 0; index < size; index++) {
    const label = choicesKey[index + idx]
    choices.push({ label, labelDisplay: label, content: '', contentImage: [] })
  }
  return choices
}

export const paperType = [] // 1,固定试题；2，每次考试随机试题；3,学员随机试题

export const examPaperQuestion = ((questionType, questionDifficulty) => {
  const list = []
  questionType.forEach(i => {
    questionDifficulty.forEach(s => {
      list.push({ typeLabel: i.label, questionType: i.value, difficultyLabel: s.label, questionDifficulty: s.value, questionCount: 0, questionPerScore: 0, maxCount: 0 })
    })
  })
  return list
})(questionType, questionDifficulty)

export const studentRegStatus = [
  { label: '报名成功', value: 1 },
  { label: '等待学员开始考试', value: 5 },
  { label: '考试中', value: 6 },
  { label: '已完成考试', value: 7 },
  { label: '考试通过', value: 8 },
  { label: '考试未通过', value: 9 },
  { label: '已中止', value: 15 },
  { label: '取消报名', value: 20 },
  { label: '过期未考试', value: 21 }
]// SUCCESS(1, "报名成功"), WAITING_STUDENT_START(5, "等待学员开始考试"), IN_EXAM(6, "考试中"), ENDED(7, "已完成考试"),
// PASSED(8, "考试通过"), FAILED(9, "考试未通过"), ABORTED(15, "已中止"), CANCELED(20, "取消报名"), EXPIRED(21, "过期未考试");

export const studentScoreStatus = [
  { label: '无成绩', value: -1 },
  { label: '待交卷', value: 0 },
  { label: '待判分', value: 1 },
  { label: '已判分', value: 3 }
]
